module.exports = __webpack_public_path__ + "img/1584407231.d0c3e3c4.jpg";